// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__oFAJmcK-","error":"Captcha_error__QvfDtWTu"};